import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class FilterSelectorAction extends BaseAction<void, {filterValue: string[]}> {

    override async run(): Promise<void | null> {
        try {
            const { filterValue } = this.params!;
            updateRecoilState("filterStateAtom", filterValue)
        } catch (error) {
            console.error("Error in FilterSelectorAction:", error);
        }
    }
}

// Create a singleton instance
export const filterSelectorAction = new FilterSelectorAction(); 